import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Modal from '../../../../../Modal';
import { AddLicenseToGroupsStore } from '../Store';
import Body from './Body';
import { ModalFormState } from './Types';

interface Props {
  state: ModalFormState;
  licenseAllocationsStore: AddLicenseToGroupsStore;
}

function ModalForm({ state, licenseAllocationsStore }: Props) {
  return (
    <Modal close={licenseAllocationsStore.waiting} title="">
      <h2 className="text-xl font-semibold">
        <T kind="Allocate License to Group Members" />
      </h2>
      <sub>
        <T kind="Select the license you want to allocate the groups..." />
      </sub>
      <Body state={state} submitting={licenseAllocationsStore.submitting} />
    </Modal>
  );
}

export default observer(ModalForm);
